import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IInitialIEPInfo } from "../Models/IInitialIEPInfo";
import { catchError } from 'rxjs/operators';

@Injectable()
export class InitialIEPInfoService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getInitialIEPInfo(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/InitialIEPInfo/" + localStudentId)
      .map((response: IInitialIEPInfo) => response as IInitialIEPInfo)
      .catch(this.errorHandler);
  }

  insertUpdateInitialIEPInfo(initialIEPInfoDetails: IInitialIEPInfo) {
    return this._http.post(this._baseUrl + 'api/InitialIEPInfo', initialIEPInfoDetails)
      .map((response: IInitialIEPInfo) => response as IInitialIEPInfo)
      .catch(this.errorHandler);
  }

  deleteInitialIEPInfo(id) {
    return this._http.delete(this._baseUrl + "api/InitialIEPInfo" + id)
      .map((response: IInitialIEPInfo) => response as IInitialIEPInfo)
      .catch(this.errorHandler)
  }

  validateInitialIEPInfo(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/InitialIEPInfo/ValidateInitialIEPInfo/" + localStudentId)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

  updateMostRecentLaserficheDocumentID(initialIEPInfoDetails: IInitialIEPInfo) {
    return this._http.post(this._baseUrl + 'api/InitialIEPInfo/updateMostRecentLaserficheDocumentID', initialIEPInfoDetails)
      .map((response: IInitialIEPInfo) => response as IInitialIEPInfo)
      .catch(this.errorHandler);
  }

  ViewLaserficheDocument(localStudentId,laserficheDocumentID): Observable<any> {
    let params = new HttpParams();
    params = params.append('localStudentId', localStudentId);
    params = params.append('laserficheDocumentID',laserficheDocumentID);
    return this._http.get<any>(this._baseUrl+"api/Oasis/GetDocumentPdf", { params: params,responseType:'arraybuffer' as 'json' });
}
}



